import { FC } from "react";
import { ChatMessage } from "../../types";
import { MessageItem } from "../messageItem";
import { Conversation, ConversationEmptyState } from "@altimateai/lego";

interface MessageListProps {
  messages: ChatMessage[];
  handleSavePrompt?: (message: ChatMessage) => void;
  showSavePromptButton?: boolean;
  emptyStateContent?: React.ReactNode;
}

export const MessageList: FC<MessageListProps> = ({
  messages,
  handleSavePrompt,
  showSavePromptButton = false,
  emptyStateContent,
}) => {
  if (messages.length === 0 && emptyStateContent) {
    return (
      <Conversation className="al-w-full">
        <ConversationEmptyState>{emptyStateContent}</ConversationEmptyState>
      </Conversation>
    );
  }

  return (
    <>
      {messages.map((message, index) => (
        <MessageItem
          key={message.id}
          message={message}
          isLastMessage={index === messages.length - 1}
          isFirstMessage={index === 0}
          handleSavePrompt={index === 0 ? handleSavePrompt : undefined}
          showSavePromptButton={index === 0 ? showSavePromptButton : false}
        />
      ))}
    </>
  );
};
